let initialState = {
	editor: true,
	design: false,
};

export const editorState = (state = initialState, action) => {
	switch (action.type) {
		case "UPDATE_EDITOR_STATE":
			return {
				editor: action.state,
				design: !action.state,
			};

		default:
			return state;
	}
};
